import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Sections.css';
import './VideoSection.css';

const VideoSection = () => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  
  const playVideo = () => {
    setVideoPlaying(true);
  };

  return (
    <section className="video-section" id="video-walkthrough">
      {/* Animated gradient elements */}
      <div className="gradient-element"></div>
      <div className="gradient-element"></div>
      <div className="gradient-element"></div>
      
      {/* Decorative orbs */}
      <div className="video-orb top-right"></div>
      <div className="video-orb bottom-left"></div>
      
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Watch the Walkthrough</h2>
          <p>A quick tour of how Vtrender<sup>™</sup> Charts delivers real-time trading clarity.</p>
        </motion.div>
        
        <motion.div 
          className="video-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="video-wrapper">
            {videoPlaying ? (
              <iframe 
                src="https://www.youtube.com/embed/JfCkV2W4wuo?autoplay=1" 
                title="Vtrender™ Charts Walkthrough" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            ) : (
              <div className="video-placeholder" onClick={playVideo}>
                <img 
                  src="https://img.youtube.com/vi/QSy9oUdZxy8/maxresdefault.jpg" 
                  alt="Vtrender™ Charts Walkthrough" 
                />
                <div className="play-button">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3A86FF" fillOpacity="0.9" />
                    <path d="M16 12L10 16V8L16 12Z" fill="white" />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
